// W-0821 — Reducer local da página Transferir Títulos para Cobrança
// ADR-003: estado intermediário do "#Transf" Delphi vive no front-end (payload completo no POST).
// Multi-seleção persiste entre páginas — Set de codigosBoleto, não dependa do array da página atual.

export const MODO_FILTROS = 'filtros';
export const MODO_RESULTADOS = 'resultados';

export const initialState = {
  filtros: {
    codigoGrupoEmpresa: null,
    codigoGrupoGes: null,
    codigoCidadeCobranca: null,
    codigoFamilia: null,
    codigoConta: null,
    diasMinimoVencidos: 60,
    diasMaximoVencidos: 21,
    codigosPerfilComprador: [],
    modoAutomatico: false,
    incluirChequeDevolvidoAlinea11: false,
  },
  resultados: {
    boletos: [],
    total: 0,
    pagina: 1,
    tamanhoPagina: 50,
    resumoCobradoresAtuais: [],
    carteiraAtiva: [],
  },
  atribuicoes: {}, // map: codigoBoleto -> cobradorCodigo
  selecionados: [], // array de codigoBoleto (Set serializado pra simplicidade)
  modo: MODO_FILTROS,
  lancamento: {
    emAndamento: false,
    chunkAtual: 0,
    totalChunks: 0,
    transferidos: [],
    ignorados: [],
    falhasExternas: [],
  },
};

export const actions = {
  SET_FILTROS: 'SET_FILTROS',
  SET_RESULTADOS: 'SET_RESULTADOS',
  TOGGLE_SELECAO: 'TOGGLE_SELECAO',
  TOGGLE_SELECAO_PAGINA: 'TOGGLE_SELECAO_PAGINA',
  LIMPAR_SELECAO: 'LIMPAR_SELECAO',
  ATRIBUIR_COBRADOR: 'ATRIBUIR_COBRADOR',
  ATRIBUIR_LOTE: 'ATRIBUIR_LOTE',
  RESET: 'RESET',
  MUDAR_MODO: 'MUDAR_MODO',
  SET_PAGINA: 'SET_PAGINA',
  RESET_LANCAMENTO: 'RESET_LANCAMENTO',
  SET_PROGRESSO_LANCAMENTO: 'SET_PROGRESSO_LANCAMENTO',
  MERGE_RESPONSE_CHUNK: 'MERGE_RESPONSE_CHUNK',
  FINALIZAR_LANCAMENTO: 'FINALIZAR_LANCAMENTO',
};

const toggle = (arr, value) =>
  arr.includes(value) ? arr.filter((v) => v !== value) : [...arr, value];

export const reducer = (state, action) => {
  switch (action.type) {
    case actions.SET_FILTROS:
      return { ...state, filtros: { ...state.filtros, ...action.payload } };

    case actions.SET_RESULTADOS:
      return {
        ...state,
        resultados: { ...state.resultados, ...action.payload },
      };

    case actions.SET_PAGINA:
      return {
        ...state,
        resultados: { ...state.resultados, pagina: action.payload },
      };

    case actions.TOGGLE_SELECAO:
      return { ...state, selecionados: toggle(state.selecionados, action.payload) };

    case actions.TOGGLE_SELECAO_PAGINA: {
      // Marca/desmarca todos os boletos da lista informada (página atual)
      const { codigos, marcar } = action.payload;
      if (marcar) {
        const novosSet = new Set(state.selecionados);
        codigos.forEach((c) => novosSet.add(c));
        return { ...state, selecionados: Array.from(novosSet) };
      }
      const novosSel = state.selecionados.filter((c) => !codigos.includes(c));
      return { ...state, selecionados: novosSel };
    }

    case actions.LIMPAR_SELECAO:
      return { ...state, selecionados: [], atribuicoes: {} };

    case actions.ATRIBUIR_COBRADOR: {
      const { codigoBoleto, cobradorCodigo } = action.payload;
      const novas = { ...state.atribuicoes };
      if (cobradorCodigo == null) {
        delete novas[codigoBoleto];
      } else {
        novas[codigoBoleto] = cobradorCodigo;
      }
      return { ...state, atribuicoes: novas };
    }

    case actions.ATRIBUIR_LOTE: {
      const { codigos, cobradorCodigo } = action.payload;
      const novas = { ...state.atribuicoes };
      codigos.forEach((c) => {
        novas[c] = cobradorCodigo;
      });
      return { ...state, atribuicoes: novas };
    }

    case actions.MUDAR_MODO:
      return { ...state, modo: action.payload };

    case actions.RESET:
      return initialState;

    case actions.RESET_LANCAMENTO:
      return { ...state, lancamento: initialState.lancamento };

    case actions.SET_PROGRESSO_LANCAMENTO:
      return {
        ...state,
        lancamento: { ...state.lancamento, ...action.payload },
      };

    case actions.MERGE_RESPONSE_CHUNK: {
      const { transferidos = [], ignorados = [], falhasExternas = [] } =
        action.payload || {};
      return {
        ...state,
        lancamento: {
          ...state.lancamento,
          transferidos: [...state.lancamento.transferidos, ...transferidos],
          ignorados: [...state.lancamento.ignorados, ...ignorados],
          falhasExternas: [
            ...state.lancamento.falhasExternas,
            ...falhasExternas,
          ],
        },
      };
    }

    case actions.FINALIZAR_LANCAMENTO:
      return {
        ...state,
        lancamento: { ...state.lancamento, emAndamento: false },
      };

    default:
      return state;
  }
};
